var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoHesperangeWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 315.06 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo_hesperange_white") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M116.66,141.45a7.12,7.12,0,0,1-7.06-7.16,8.65,8.65,0,0,1,.48-2.78c2.44-7,3.78-11.88,4.89-15.47a10.2,10.2,0,0,0,.42-2.94,8.78,8.78,0,0,0-1-4.32c-.5-.76-2.06-3-3.6-5.23s-3.15-4.42-3.5-4.81h0c-.07-.06,0,0-.12,0a1.33,1.33,0,0,0-.52.16c-.7.35-3.77,1.82-6.88,3.32s-6.27,3.06-6.8,3.37l-.08.06-.23.24a8.47,8.47,0,0,0-.58.73,5.5,5.5,0,0,0-.71,1.3,7.84,7.84,0,0,1-.33.88L90.5,110c-.46,1-1.09,2.34-1.84,3.92-1.49,3.16-3.46,7.26-5.41,11.33-3.91,8.14-7.79,16.14-7.79,16.14l-3.68-1.78L78,126.79c3.29-6.84,7-14.59,8.68-18.2.44-1,.76-1.69.81-1.82a9,9,0,0,1,1.3-2.54,8.21,8.21,0,0,1,2-2.1c.31-.2.54-.31,1-.54l1.58-.79c1.24-.61,2.83-1.39,4.43-2.16,3.2-1.55,6.5-3.13,7.13-3.45a5.23,5.23,0,0,1,2.35-.58,4.23,4.23,0,0,1,3,1.23,23.32,23.32,0,0,1,1.55,2c.65.9,1.45,2,2.26,3.17,1.61,2.3,3.24,4.68,3.81,5.52a12.48,12.48,0,0,1,1.67,6.59,14.11,14.11,0,0,1-.6,4.14c-1.08,3.5-2.46,8.47-4.93,15.61a4.31,4.31,0,0,0-.26,1.44,3,3,0,0,0,3,3.07c1.25-.05,2.78-.68,3.73-4.06,1.25-4.86,9.45-36,17.22-65.43l4,1c-7.77,29.46-16,60.59-17.22,65.41-1.09,4.56-4.32,7.13-7.59,7.13h-.1",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.26,66s19.35,10.63,72.5,10.63S205.5,63.77,280.45,37.33l34.61,5.45S213.4,81.48,108.47,81.48c-42.24,0-79.85-6.26-108.47-15Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.86,140.25l6.81-13.41L80.51,95.56c12-23.81,25.56-50.58,31.39-62.37,1.65-3.33,2.74-5.58,2.85-5.88a7.28,7.28,0,0,1,1.54-2.51,3.58,3.58,0,0,1,2.52-1.12,3.54,3.54,0,0,1,2.82,1.51,4.4,4.4,0,0,1,.88,2.6c0,1.37-.38,3.33-.37,4.77a4.5,4.5,0,0,0,0,.83,4.34,4.34,0,0,0,2.21.57l.51,0L136.61.46l1.07-.27a7.5,7.5,0,0,1,1.7-.19,6,6,0,0,1,2.53.53,4.46,4.46,0,0,1,2.3,2.63,10.26,10.26,0,0,1,.43,3.16c0,1.18-.11,2.28-.11,3a4.47,4.47,0,0,0,.06.8,3.92,3.92,0,0,0,.77.89l.36-.61c.43-.74.93-1.71,1.39-2.66.93-1.9,1.74-3.7,1.74-3.71l.5-1.14,1.25-.07H151a9.71,9.71,0,0,1,2.29.27,5.67,5.67,0,0,1,3.14,1.82,4.61,4.61,0,0,1,1,2.95c0,.14,0,.28,0,.44a13.34,13.34,0,0,1-1.23,5.27c-.36,1.36-2,7.68-4.43,16.8-2.73,10.33-6.39,24.22-10.16,38.51l-4-1,14.67-55.58.1-.38.19-.25h0a2.73,2.73,0,0,0,.19-.47A13,13,0,0,0,153.31,8s0-.1,0-.14c0-.28,0-.28-.09-.35a1.2,1.2,0,0,0-.49-.3A3.15,3.15,0,0,0,152,7c-.24.52-.53,1.15-.85,1.82a40.88,40.88,0,0,1-2.61,4.8,4.27,4.27,0,0,1-.95,1.07,3.29,3.29,0,0,1-2,.64,4.49,4.49,0,0,1-2.82-1.13,7.83,7.83,0,0,1-1.73-2,5.63,5.63,0,0,1-.62-2.86c0-1.06.11-2.11.11-3a6.08,6.08,0,0,0-.22-1.86c-.09-.22-.07-.16-.2-.25a1.45,1.45,0,0,0-.46-.11l-11.6,33.19-.91.33a8.54,8.54,0,0,1-2.76.43,8.4,8.4,0,0,1-4.84-1.5,3.49,3.49,0,0,1-1.32-2.07,8.51,8.51,0,0,1-.19-1.92c0-1.05.12-2.2.22-3.12-.46,1-1.37,2.86-2.71,5.57-1.67,3.38-4,8-6.67,13.37-5.42,10.8-12.49,24.81-19.51,38.69-14,27.77-27.87,55-27.87,55h0ZM144.6,10.18Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.92,114.29a6.34,6.34,0,1,1,6.34,6.34,6.33,6.33,0,0,1-6.34-6.34m3.27,0a3.07,3.07,0,1,0,3.07-3.06,3.08,3.08,0,0,0-3.07,3.06",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.33,25.8a3.45,3.45,0,0,1-2-3.21c0-.13,0-.26,0-.38a4.57,4.57,0,0,1,1.86-3.34,5.17,5.17,0,0,1,3-1,5.09,5.09,0,0,1,.56,0l-.21,1.42-.21,1.41h-.14a2.31,2.31,0,0,0-1.29.45,1.66,1.66,0,0,0-.71,1.28.71.71,0,0,0,0,.14c.05.47.07.41.41.63a3.09,3.09,0,0,0,1.23.24h0a.71.71,0,0,0,.18-.07,1.84,1.84,0,0,0,.54-.34,1.69,1.69,0,0,0,.65-1.07,1.85,1.85,0,0,0,0-.23c0-.7-.26-.83-.92-1l.21-1.41.21-1.42a3.81,3.81,0,0,1,3.36,3.84,5.4,5.4,0,0,1,0,.56,4.58,4.58,0,0,1-1.65,2.93,4.2,4.2,0,0,1-2.59,1.09,5.91,5.91,0,0,1-2.49-.52",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.5,38.43a3.46,3.46,0,0,1-2-3.22,2.36,2.36,0,0,1,0-.38,4.56,4.56,0,0,1,1.85-3.34,5.19,5.19,0,0,1,3-1,3.56,3.56,0,0,1,.57,0,3.81,3.81,0,0,1,3.36,3.84,5.25,5.25,0,0,1,0,.56,4.58,4.58,0,0,1-1.65,2.93,4.2,4.2,0,0,1-2.6,1.09,5.81,5.81,0,0,1-2.48-.51m1.55-4.64a1.66,1.66,0,0,0-.71,1.28.76.76,0,0,0,0,.14c0,.47.07.41.41.63a3.2,3.2,0,0,0,1.23.24h0l.19-.06a2.38,2.38,0,0,0,.54-.34,1.77,1.77,0,0,0,.64-1.08,2,2,0,0,0,0-.23c-.06-.7-.27-.84-.92-1l.21-1.41-.21,1.41h-.17a2.36,2.36,0,0,0-1.26.45",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.21,
    y: -27.95,
    width: 3.27,
    height: 99.08,
    transform: "translate(146.21 225.61) rotate(-77.43)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.01,
    y: 1.08,
    width: 3.27,
    height: 56.16,
    transform: "translate(109.85 204.28) rotate(-73.93)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168.57,
    y: 27.26,
    width: 3.27,
    height: 23.41,
    transform: "translate(63.49 177.17) rotate(-65.22)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.45,
    y: 35.39,
    width: 78.75,
    height: 3.27,
    transform: "translate(-8.73 39.51) rotate(-28.36)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.87,
    y: 36,
    width: 22.79,
    height: 3.27,
    transform: "translate(-6.3 51.4) rotate(-29.56)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.84,106.55a10.49,10.49,0,0,1-4.22.86,6.33,6.33,0,0,1-5.35-2.23,7.28,7.28,0,0,1-1.42-4.64A10.59,10.59,0,0,1,158,93a9.53,9.53,0,0,1,6.5-2.5,6.88,6.88,0,0,1,3.6.78l-.41.93a7,7,0,0,0-3.46-.73,8,8,0,0,0-5.69,2.42,9.66,9.66,0,0,0-2.53,6.48c0,3.46,1.57,6,5.91,6a7.91,7.91,0,0,0,3-.56l1.23-6.77,1.15,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.85,106.55a6.53,6.53,0,0,1-3.56,1c-3,0-4.09-2.28-4.09-4.61,0-3.51,2.65-7.7,6.15-7.7,2.14,0,3.05,1.32,3.05,2.7,0,3.16-3.83,3.8-8,3.72a6.47,6.47,0,0,0,.17,2.9,2.8,2.8,0,0,0,2.84,2,5.94,5.94,0,0,0,3.09-.84Zm.42-8.6c0-1.18-.91-1.8-2.11-1.8-2.14,0-3.9,2.24-4.56,4.54,3.48,0,6.67-.41,6.67-2.72Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.6,107.24l1.62-8.61c.24-1.2.39-2.23.51-3.16h1l-.37,2.38h.05a5.16,5.16,0,0,1,4.25-2.65c1.74,0,2.65,1.1,2.72,2.87a5.11,5.11,0,0,1,4.49-2.87,2.8,2.8,0,0,1,2.84,3,11.45,11.45,0,0,1-.17,2l-1.35,7h-1.1l1.32-7a8,8,0,0,0,.17-1.6c0-1.52-.54-2.45-2.15-2.45s-3.78,1.79-4.3,4.59l-1.2,6.47h-1.1l1.37-7.19a6.2,6.2,0,0,0,.17-1.49c0-1.1-.29-2.38-2.18-2.38-1.64,0-3.87,2.13-4.34,4.76l-1.18,6.3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.7,106.55a6.53,6.53,0,0,1-3.56,1c-3,0-4.09-2.28-4.09-4.61,0-3.51,2.65-7.7,6.16-7.7,2.13,0,3,1.32,3,2.7,0,3.16-3.83,3.8-8,3.72a6.47,6.47,0,0,0,.17,2.9,2.8,2.8,0,0,0,2.84,2,5.9,5.9,0,0,0,3.09-.84Zm.42-8.6c0-1.18-.91-1.8-2.11-1.8-2.13,0-3.9,2.24-4.56,4.54,3.48,0,6.67-.41,6.67-2.72Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.45,107.24l1.62-8.61c.24-1.2.39-2.23.51-3.16h1L212.24,98h0a5.38,5.38,0,0,1,4.54-2.79c1.06,0,2.94.56,2.94,3.28a10.26,10.26,0,0,1-.22,1.87l-1.3,6.89h-1.1l1.32-7a10.43,10.43,0,0,0,.18-1.62c0-1.4-.57-2.45-2.26-2.45s-4.17,1.91-4.73,5l-1.11,6Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.79,110.58a5.61,5.61,0,0,0,3.14.86c2.15,0,3.87-1.16,4.71-4.89l.49-2.25h0a5.19,5.19,0,0,1-4.56,3c-2.38,0-3.46-2.06-3.46-4,0-4.09,3-8.09,7.21-8.09a8.31,8.31,0,0,1,3.41.81l-1.82,9.76c-.51,2.7-1.2,4.29-2.3,5.3a5.69,5.69,0,0,1-3.85,1.3,5.87,5.87,0,0,1-3.34-.89Zm9.66-13.91a5.63,5.63,0,0,0-2.4-.52c-3.49,0-5.84,3.56-5.86,6.9,0,1.37.41,3.28,2.67,3.28s4.27-2.74,4.73-5.25Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "155.8 112.92 153.47 125 166.64 125 168.94 112.92 172.51 112.92 167.03 141.58 163.5 141.58 166.05 128.1 152.87 128.1 150.32 141.58 146.79 141.58 152.27 112.92 155.8 112.92",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.16,140.39a14.19,14.19,0,0,1-6.8,1.66c-5.45,0-7.83-3.74-7.83-8.29,0-6.21,4.59-13.23,11.22-13.23,3.92,0,6,2.34,6,5.28,0,5.4-6.08,6.84-13.69,6.72a8.52,8.52,0,0,0,.43,3.91,4.67,4.67,0,0,0,4.59,2.76,11.64,11.64,0,0,0,5.53-1.44Zm-.77-14.5c0-1.66-1.27-2.59-3.14-2.59-3.36,0-5.87,3.27-6.72,6.5,5.52,0,9.86-.68,9.86-3.87Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.75,138a9.31,9.31,0,0,0,4.42,1.27c2.38,0,3.91-1.53,3.91-3.35,0-1.62-.72-2.6-2.85-3.79-2.38-1.31-3.69-3.14-3.69-5.23,0-3.61,3.1-6.38,7.43-6.38a8.59,8.59,0,0,1,4.3,1l-1,2.67a7.41,7.41,0,0,0-3.57-.93c-2.13,0-3.66,1.32-3.66,3.1,0,1.49,1,2.43,2.81,3.44,2.3,1.32,3.87,3.11,3.87,5.41,0,4.33-3.53,6.8-7.87,6.8a9.35,9.35,0,0,1-5.1-1.45Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.61,150l4.12-21.69c.43-2.46.85-5.27,1.15-7.35h3.23l-.59,3.91h.08a9.29,9.29,0,0,1,7.4-4.33c4.46,0,6.33,3.65,6.33,7.43,0,7.23-5.18,14.08-12,14.08a9,9,0,0,1-4.46-.94h-.09L210.1,150Zm5.78-11.86a6.25,6.25,0,0,0,3.91,1.1c4.55,0,8.38-5.61,8.38-11,0-2.17-1-4.76-4-4.76-2.76,0-6.25,3.19-7.31,8.93Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.72,140.39a14.19,14.19,0,0,1-6.8,1.66c-5.44,0-7.82-3.74-7.82-8.29,0-6.21,4.59-13.23,11.22-13.23,3.91,0,6,2.34,6,5.28,0,5.4-6.08,6.84-13.69,6.72a8.64,8.64,0,0,0,.42,3.91,4.69,4.69,0,0,0,4.6,2.76,11.56,11.56,0,0,0,5.52-1.44Zm-.76-14.5c0-1.66-1.28-2.59-3.15-2.59-3.36,0-5.87,3.27-6.72,6.5,5.53,0,9.87-.68,9.87-3.87Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.15,141.58l2.5-13.26c.51-2.68.85-5.4,1.07-7.32h3.1c-.17,1.45-.34,2.89-.55,4.47h.13c1.31-2.81,3.52-4.94,6.29-4.94a7.12,7.12,0,0,1,1,.09l-.67,3.49a4.52,4.52,0,0,0-.94-.09c-3.06,0-5.78,3.7-6.67,8.5l-1.71,9.06Z",
    style: {
      fill: "#fff"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoHesperangeWhite);
export default __webpack_public_path__ + "static/media/logo_hesperange_white.06faabe90d21cf60840253c9c818f52d.svg";
export { ForwardRef as ReactComponent };